import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getBrPageContent } from '../utils/get-br-page-content.js';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { parseBloomreachImage } from '../utils/parse-bloomreach-image.js';
import { mapBloomreachLinks } from './use-bloomreach-links.js';
import { useBloomreachPageModels } from './use-bloomreach-page-models.js';

const useBloomreachDeliveryInfo = ()=>{
    const page = useBrPageContext();
    const pageModels = useBloomreachPageModels();
    const deliveryDocumentContent = getBrPageContent(page, pageModels === null || pageModels === void 0 ? void 0 : pageModels.deliveryInfo);
    if (!deliveryDocumentContent) {
        var ref;
        console.warn(`Cannot find main content for Delivery Info. Got: ${deliveryDocumentContent} for $ref: ${pageModels === null || pageModels === void 0 ? void 0 : (ref = pageModels.deliveryInfo) === null || ref === void 0 ? void 0 : ref.$ref}`);
        return undefined;
    }
    const { deliveryItems: deliveryItemsRefs = [] , description , link: brLink , linkHint , title ,  } = deliveryDocumentContent;
    const brLinks = brLink ? [
        brLink
    ] : [];
    const [link] = mapBloomreachLinks(brLinks, page);
    const deliveryItemsContents = deliveryItemsRefs.map((ref)=>getBrPageContent(page, ref)
    );
    const items = deliveryItemsContents.filter((deliveryItemContent)=>{
        return !!(deliveryItemContent === null || deliveryItemContent === void 0 ? void 0 : deliveryItemContent.title);
    }).map((deliveryItemContent)=>{
        return {
            description: (deliveryItemContent === null || deliveryItemContent === void 0 ? void 0 : deliveryItemContent.description.value) || '',
            id: (deliveryItemContent === null || deliveryItemContent === void 0 ? void 0 : deliveryItemContent.id) || '',
            image: parseBloomreachImage(deliveryItemContent === null || deliveryItemContent === void 0 ? void 0 : deliveryItemContent.image),
            price: (deliveryItemContent === null || deliveryItemContent === void 0 ? void 0 : deliveryItemContent.price) || '',
            title: (deliveryItemContent === null || deliveryItemContent === void 0 ? void 0 : deliveryItemContent.title) || ''
        };
    });
    return {
        items,
        description: (description === null || description === void 0 ? void 0 : description.value) || '',
        link,
        linkHint,
        title
    };
};

export { useBloomreachDeliveryInfo };
//# sourceMappingURL=use-bloomreach-delivery-info.js.map
